export const AppEnvironments = {
  Development: 'development',
  Production: 'production',
  CTD: 'ctd',
};

export const AlertTypes = {
  approve: 'approve',
  decline: 'decline',
  error: 'error',
};

export const AppSettingConfigurations = {
  PendingAgreements: 'PendingAgreementsConfiguration',
  ProductCategoryDateRange: 'ProductCategoryDateRange',
};

export const PendingAgreementConfigurations = {
  Status: 'PendingAgreementStatus',
  EmailTypes: 'EmailTypes',
  PendingBookingStatus: 'SelectedPendingBookingStatus',
  PendingPrepayStatus: 'SelectedPendingPrepayStatus',
  SignatureRequired: 'SignatureRequiredStatus',
  ButtonQuote: 'ButtonQuote',
  ButtonPendingBooking: 'ButtonPendingBooking',
  ButtonBooking: 'ButtonBooking',
  ButtonPendingPrepay: 'ButtonPendingPrepay',
  ButtonPrepay: 'ButtonPrepay',
  HideQuoteButton: 'HideQuoteButton',
  HidePrepayButton: 'HidePrepayButton',
  HideBookingButton: 'HideBookingButton',
  SameBookingNumber: 'SameBookingNumberStatus',
  RemarkNumberForFarmAndField: 'RemarkNumberForFarmAndField',
  RemarkNumberForBookingProgram: 'RemarkNumberForBookingProgram',

};

export const StorageKeys = {
  AuthToken: 'token'
}